import 'console-shim';
import React from 'react';
import ReactDOM from 'react-dom';
import root from 'window-or-global';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import {fromJS} from 'immutable';
import {setLocale} from '@epic-core/common';
import {ScrollToTopOnUpdate} from '../client/components';
import {alt} from 'epic-react-common';
import {configureStore} from './configureStore';
import pako from 'pako';
import App from './App';
import axios from 'axios';
import {redirectLogin} from './utils';
import {configureTracking} from './utils/TrackingUtils';
import {bootstrapSharedValues, sharedStore, configureServices} from './app.initializers';
import {LocalizationContext, mergeLocalizationDataAltStore} from '@epic-core/localization';
import {SharedValueContext} from '@epic-core/hooks';

const configureAxios = preload => {
    axios.defaults.timeout = 15000;
    axios.interceptors.request.use(config => {
        const xEnvStr = preload.config ? preload.config.xEnvStr : '';
        if (xEnvStr) {
            config.headers['x-epic-env'] = xEnvStr;
        }
        return config;
    });
    axios.interceptors.response.use(
        response => {
            return response;
        },
        err => {
            if (err.response && err.response.status === 401) {
                redirectLogin();
                return null;
            }
            return Promise.reject(err);
        }
    );
};

const init = () => {
    let initialState = fromJS({});
    if (root.__epic_client_state) {
        setLocale(root.__locale);
        const preload = JSON.parse(
            pako.inflate(root.__epic_client_state.split(','), {to: 'string'})
        );
        root.__epic_client_state = preload;
        initialState = fromJS(preload);
        configureTracking(initialState);
        configureAxios(preload);
    }

    const renderClient = function renderClient() {
        let LocalizationStore = {};
        const localization = initialState.get('localization').toJS();
        setLocale(localization.locale);
        localization.messages = localization.messageProperties;
        LocalizationStore = {
            messages: localization.messageProperties,
            i18nMessages: localization.messageProperties,
            loaded: true,
            supportedLocales: localization.supportedLocales,
            locale: localization.locale
        };

        if (root.__epic_react_common_localization) {
            root.__epic_react_common_localization = null;
            alt.bootstrap({
                LocalizationStore
            });
        }

        const store = configureStore(initialState);
        root.reduxStore = store;

        const i18nContext = mergeLocalizationDataAltStore(LocalizationStore);
        ReactDOM.hydrate(
            <BrowserRouter>
                <SharedValueContext.Provider value={sharedStore}>
                    <LocalizationContext.Provider value={i18nContext}>
                        <Provider store={store}>
                            <ScrollToTopOnUpdate>
                                <App />
                            </ScrollToTopOnUpdate>
                        </Provider>
                    </LocalizationContext.Provider>
                </SharedValueContext.Provider>
            </BrowserRouter>,
            root.document.getElementById('bodyWrapper')
        );
    };

    bootstrapSharedValues(root.__epic_client_state).then(() => {
        configureServices();
        renderClient();
    });
};

init();
